import { FormattedMessage } from 'react-intl'
import { useSmartBack } from '@hooks/useSmartBack'

import './BackButton.css'

interface BackButtonProps {
  to?: string
}

export default function BackButton({ to }: BackButtonProps) {
  const { goBack: smartGoBack } = useSmartBack(to)

  return (
    <button
      className="button back-button"
      type="button"
      onClick={() => smartGoBack()}
    >
      <span className="icon icon-angle-left" />
      <span className="text">
        <FormattedMessage id="back" />
      </span>
    </button>
  )
}
